export default __webpack_public_path__ + "static/media/icn-message-error.f7ff1273.svg";